module.exports = __webpack_public_path__ + "img/gb13871-92-40x55x8.prt.37dba146.jpg";